"use client"

import { Loader2, ExternalLink } from "lucide-react"
import { usePostChatbotJoin } from "openapi/api/endpoints"
import type { PostChatbotJoinBody } from "openapi/api/model"
import { toast } from "sonner"

type JoinMeetingLinkProps = {
  meetingUrl: string
  payload?: PostChatbotJoinBody | null
}

export function JoinMeetingLink({ meetingUrl, payload }: JoinMeetingLinkProps) {
  const { mutateAsync: postChatbotJoin, isPending } = usePostChatbotJoin()

  const handleClick = () => {
    if (!payload || isPending) return

    void postChatbotJoin({ data: payload }).catch((error) => {
      toast.error("Meeting opened, but the notetaker could not join", {
        description: `${error}`,
        className: "text-white",
        descriptionClassName: "text-white",
        action: { label: "Dismiss", onClick: () => {} },
        style: { background: "#dc2626" },
      })
    })
  }

  return (
    <div className="flex items-center gap-2 text-xs">
      {isPending && payload ? (
        <Loader2 className="h-3 w-3 animate-spin text-muted-foreground" />
      ) : (
        <ExternalLink className="h-3 w-3 text-muted-foreground" />
      )}
      <a
        href={meetingUrl}
        target="_blank"
        rel="noreferrer"
        className="underline underline-offset-2 break-all"
        onClick={(event) => {
          event.stopPropagation()
          handleClick()
        }}
      >
        Join meeting
      </a>
    </div>
  )
}
